import { QuestMakerMode } from "./quest-maker-mode.js";

export class EditorMode extends QuestMakerMode {
}
